module.exports = __webpack_public_path__ + "static/media/garage-large.81db125b.webp";